import { getFileExtension } from './getFileExtension';
import { MIME_TYPE_EXTENSION_LOOKUPS, MimeTypeDefinition } from './mime-types';

/** Lookup the mimetype based on the name of the file.  Internally this handles the lookup in a case-insensitive manner. */
export function lookupMimeType(fileName: string): MimeTypeDefinition | null {
  const extension = getFileExtension(fileName)?.toLowerCase?.();
  return extension == null ? null : MIME_TYPE_EXTENSION_LOOKUPS.get(extension) ?? null;
}
